// extracted by mini-css-extract-plugin
export default {"loaderFixedContainer":"Loader_loaderFixedContainer__70N23","loadingAnimation":"Loader_loadingAnimation__n4d21","loading-animation":"Loader_loading-animation__OfgWo"};